import { HospitalInfoMapper } from "@/data/mapper/hospital-info-mapper";
import { HospitalInfoValidMapper } from "@/data/mapper/hostpital-info-valid-mapper";
import { safeMapToEntity } from "@/data/repo-Implement/safe-map-to-entity";
import { AddHospitalRequestPayload } from "@/data/payload/admin/add-hospital-request-payload";
import { DeleteHospitalRequestPayload } from "@/data/payload/admin/delete-hospital-request-payload";
import { HospitalInfoRequestPayload } from "@/data/payload/hospital-info-request-payload";
import { HospitalSource } from "@/data/source/hospital-source";
import { HospitalInfoEntity } from "@/domain/entity/hospital-info-entity";
import { HospitalValidInfoEntity } from "@/domain/entity/hospital-valid-info-entity";
import { HospitalRepository } from "@/domain/repository/hospital-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class HospitalRepositoryImpl implements HospitalRepository {
  constructor(private readonly hospitalSource: HospitalSource) {}

  /**
   * 병원 정보 조회
   * @param payload - 병원 정보 조회에 필요한 정보
   * @returns 병원 정보 엔티티 또는 에러
   */
  async getHospitalInfo(
    payload: HospitalInfoRequestPayload
  ): Promise<SATResult<HospitalInfoEntity, SATError>> {
    const result = await this.hospitalSource.getHospitalInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      HospitalInfoMapper.toEntity,
      "HospitalRepositoryImpl::getHospitalInfo"
    );
  }

  /**
   * 병원 정보 유효성 검증
   * @param payload - 병원 정보 유효성 검증에 필요한 정보
   * @returns 병원 유효성 정보 엔티티 또는 에러
   */
  async validateHospitalInfo(
    payload: HospitalInfoRequestPayload
  ): Promise<SATResult<HospitalValidInfoEntity, SATError>> {
    const result = await this.hospitalSource.validateHospitalInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }

    return safeMapToEntity(
      result.value,
      HospitalInfoValidMapper.toEntity,
      "HospitalRepositoryImpl::validateHospitalInfo"
    );
  }

  async addHospitalInfo(
    payload: AddHospitalRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.hospitalSource.addHospitalInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }

  async getHospitalList(): Promise<SATResult<HospitalInfoEntity[], SATError>> {
    const result = await this.hospitalSource.getHospitalList();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return safeMapToEntity(
      result.value,
      HospitalInfoMapper.toEntityList,
      "HospitalRepositoryImpl::getHospitalList"
    );
  }

  async deleteHospitalInfo(
    payload: DeleteHospitalRequestPayload
  ): Promise<SATResult<void, SATError>> {
    const result = await this.hospitalSource.deleteHospitalInfo(payload);
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(void 0);
  }
}
